import React from 'react';
import { Shield, Brain, Network, Users } from 'lucide-react';
import '../styles.css';

const MissionSection: React.FC = () => {
  return (
    <section className='mission-section'>
      <div className='mission-container'>
        <div className='mission-header'>
          <div style={{ display: 'inline-block' }}>
            <h2>Why Athena Matters</h2>
            <div className='mission-title-underline' />
          </div>
          <p>
            Athena transforms how defense research happens - connecting the right
            people to the right information at the moment it matters most.
          </p>
        </div>

        <div className='mission-grid'>
          {/* Card 1: Authentic Content */}
          <div
            className='mission-card'
            tabIndex={0}
            role='article'
            aria-label='Authentic Content advantage'
          >
            <div className='mission-icon-wrapper'>
              <div className='mission-icon'>
                <Shield />
              </div>
            </div>
            <h3>Authentic Content</h3>
            <p>Curated resources vetted by subject matter experts</p>
          </div>

          {/* Card 2: AI-Enhanced, Human-Centered */}
          <div
            className='mission-card'
            tabIndex={0}
            role='article'
            aria-label='AI-Enhanced, Human-Centered advantage'
          >
            <div className='mission-icon-wrapper'>
              <div className='mission-icon'>
                <Brain />
              </div>
            </div>
            <h3>AI-Enhanced, Human-Centered</h3>
            <p>AI augments discovery without replacing expertise</p>
          </div>

          {/* Card 3: Flexible Architecture */}
          <div
            className='mission-card'
            tabIndex={0}
            role='article'
            aria-label='Flexible Architecture advantage'
          >
            <div className='mission-icon-wrapper'>
              <div className='mission-icon'>
                <Network />
              </div>
            </div>
            <h3>Flexible Architecture</h3>
            <p>Evolves with changing research demands</p>
          </div>

          {/* Card 4: Resource-Linked Collaboration */}
          <div
            className='mission-card'
            tabIndex={0}
            role='article'
            aria-label='Resource-Linked Collaboration advantage'
          >
            <div className='mission-icon-wrapper'>
              <div className='mission-icon'>
                <Users />
              </div>
            </div>
            <h3>Resource-Linked Collaboration</h3>
            <p>Connects people across institutional boundaries</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionSection;
